import { render, staticRenderFns } from "./abcQrcode.vue?vue&type=template&id=2764c30b"
import script from "./abcQrcode.vue?vue&type=script&lang=js"
export * from "./abcQrcode.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("E:\\web\\medical\\medical-autism\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2764c30b')) {
      api.createRecord('2764c30b', component.options)
    } else {
      api.reload('2764c30b', component.options)
    }
    module.hot.accept("./abcQrcode.vue?vue&type=template&id=2764c30b", function () {
      api.rerender('2764c30b', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/autism/childrenAbcScale/abcQrcode/abcQrcode.vue"
export default component.exports